<template>
  <div class="app">
    <AppHeader fixed>
      <SidebarToggler class="d-lg-none" display="md" mobile />
      <b-link class="navbar-brand" to="#">
        <img class="navbar-brand-full" src="img/logo.png" width="89" height="25" alt="Pennylender Logo">
        <img class="navbar-brand-minimized" src="img/logo.png" width="30" height="30" alt="Pennylender Logo">
      </b-link>
      <SidebarToggler class="d-md-down-none" display="lg" :defaultOpen=true />
      <b-navbar-nav class="d-md-down-none">
        <b-nav-item class="px-3" to="/dashboard">Dashboard</b-nav-item>
        <b-nav-item v-if="access.includes(role)" class="px-3" to="/configurations/users" exact>Users</b-nav-item>
        <b-nav-item v-if="access.includes(role)" class="px-3" to="/configurations/system-settings">Settings</b-nav-item>
      </b-navbar-nav>
      <b-navbar-nav class="ml-auto">
        <DefaultHeaderDropdownAccnt/>
      </b-navbar-nav>
    </AppHeader>
    <div class="app-body">
      <AppSidebar fixed>
        <SidebarHeader/>
        <SidebarForm/>
        <SidebarNav :navItems="nav"></SidebarNav>
        <SidebarFooter/>
        <SidebarMinimizer/>
      </AppSidebar>
      <main class="main">
        <IdleModal v-if="isIdle" />
        <Breadcrumb :list="list"/>
        <div class="container-fluid">
          <router-view></router-view>
        </div>
      </main>
      <AppAside fixed>
        <DefaultAside/>
      </AppAside>
    </div>
    <TheFooter>
      <!--footer-->
      <div>
        <a href="https://coreui.io">Pennylender</a>
        <span class="ml-1">&copy; {{ new Date().getFullYear() }}.</span>
      </div>
      <div class="ml-auto"> </div>
    </TheFooter>
  </div>
</template>

<script>
import nav from '@/_nav';
import IdleModal from '@/components/IdleModal';
import { mapState, mapGetters, mapActions } from 'vuex';
import { Header as AppHeader, SidebarToggler, Sidebar as AppSidebar, SidebarFooter, SidebarForm, SidebarHeader, SidebarMinimizer, SidebarNav, Aside as AppAside, AsideToggler, Footer as TheFooter, Breadcrumb } from '@coreui/vue'
import DefaultAside from './DefaultAside'
import DefaultHeaderDropdownAccnt from './DefaultHeaderDropdownAccnt';

export default {
  name: 'DefaultContainer',
  components: {
    AsideToggler,
    AppHeader,
    AppSidebar,
    AppAside,
    TheFooter,
    Breadcrumb,
    DefaultAside,
    DefaultHeaderDropdownAccnt,
    SidebarForm,
    SidebarFooter,
    SidebarToggler,
    SidebarHeader,
    SidebarNav,
    SidebarMinimizer,
    IdleModal
  },
  data () {
    return {
      nav: [],
      access: ['administrator'],
      role: ''
    }
  },
  computed: {
    ...mapState([
      'roles',
      'permissions'
    ]),
    name() {
      return this.$route.name
    },
    list() {
      return this.$route.matched.filter((route) => route.name || route.meta.label )
    },
    isIdle() {
      return this.$store.state.idleVue.isIdle;
  	}
  },
  beforeRouteEnter(to, from, next) {
    const token = localStorage.getItem('jwt');
    if (token == null) {
      next('/login')
    } else {
      next()
    }
  },
  created() {
    this.role = this.roles[0].name;
  },
  beforeMount() {
    const role = this.roles[0];
    switch (role.name) {
      case 'administrator':
        this.nav = nav.admin;
        break;
      case 'risk':
        this.nav = nav.risk;
        break;
      case 'operations':
        this.nav = nav.operations;
        break;
      case 'sales and marketing':
        this.nav = nav.sales;
        break;
      case 'collection and recovery':
        this.nav = nav.collections;
        break;
      case 'finance and account':
        this.nav = nav.finance;
        break;
      default:
        break;
    } 
  }
}
</script>
